export enum FeatureFlags {
  TEST_EXPERIMENT = 'test-experiment',
  LINK_BANK_ACCOUNT = 'link-bank-account',
}

export enum ExperimentVariant {
  CONTROL = 'control',
  TREATMENT = 'treatment',
  OFF = 'off',
}
